import { z } from "zod";

const hsCodeSchema = z
  .string()
  .nullable()
  .refine(
    (value) =>
      value === null ||
      (/^\d+$/.test(value) && value.length >= 6 && value.length <= 10),
    {
      message: "HS Code must be a string of 6-10 digits or null",
    },
  );
export const SaveSaleProduct = z.object({
  productId: z.string(),
  hsCode: hsCodeSchema,
});

export type SaveSaleProduct = z.infer<typeof SaveSaleProduct>;
